var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.01 5.6C13.01 4.71635 13.7263 4 14.61 4H29.5934C30.0393 4 30.465 4.18607 30.7678 4.51335L36.051 10.2232C36.3246 10.5189 36.4766 10.907 36.4766 11.3099V34.4C36.4766 35.2837 35.7603 36 34.8766 36H14.61C13.7263 36 13.01 35.2837 13.01 34.4V5.6ZM18.8766 14.6667C18.5821 14.6667 18.3433 14.9054 18.3433 15.2C18.3433 15.4946 18.5821 15.7333 18.8766 15.7333H30.0766C30.3712 15.7333 30.61 15.4946 30.61 15.2C30.61 14.9054 30.3712 14.6667 30.0766 14.6667H18.8766ZM18.3433 19.4667C18.3433 19.1721 18.5821 18.9333 18.8766 18.9333H30.0766C30.3712 18.9333 30.61 19.1721 30.61 19.4667C30.61 19.7612 30.3712 20 30.0766 20H18.8766C18.5821 20 18.3433 19.7612 18.3433 19.4667ZM18.8766 23.2C18.5821 23.2 18.3433 23.4388 18.3433 23.7333C18.3433 24.0279 18.5821 24.2667 18.8766 24.2667H30.0766C30.3712 24.2667 30.61 24.0279 30.61 23.7333C30.61 23.4388 30.3712 23.2 30.0766 23.2H18.8766ZM4.77122 11.7672L11.9433 7.52831V11.6884L6.36424 17.4106L4.23176 13.9647C3.7739 13.2089 4.01543 12.2251 4.77122 11.7672ZM11.9433 13.2163L4.83941 20.5025C4.22254 21.1353 4.23538 22.1482 4.86808 22.7651L11.9433 30.0127V13.2163Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3);
export default __webpack_public_path__ + "static/media/frame3.648d24ce22002141b9ebe7bb44ebe517.svg";
export { ForwardRef as ReactComponent };